import { render, staticRenderFns } from "./ft.vue?vue&type=template&id=10645f6e&scoped=true"
import script from "./ft.vue?vue&type=script&lang=js"
export * from "./ft.vue?vue&type=script&lang=js"
import style0 from "./ft.vue?vue&type=style&index=0&id=10645f6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10645f6e",
  null
  
)

export default component.exports